import { Controller } from "@hotwired/stimulus"

// A form that sends itself when one of its fields changes (a month picker).
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
